// extracted by mini-css-extract-plugin
export default {"site-performance-container":"ProductMix_site-performance-container__plj5d","site-performance-header":"ProductMix_site-performance-header__u8i4M"};